<template>
  <TeaserView v-if="!report_exist"></TeaserView>
  <div v-else class="home-page">
    <sticky-header
      v-if="showSticky"
      :style="{ opacity: opacityStickyHeader }"
      class="smooth-opacity"
    ></sticky-header>
    <smooth-reflow>
      <header-view></header-view>
    </smooth-reflow>
    <TransitionGroup name="fade" tag="div" class="home-page-content">
      <grid-item
        v-for="(item, index) in reports"
        :data="item"
        :key="index"
        @on-click="onClickReport(item)"
      ></grid-item>
    </TransitionGroup>
    <PopupReport
      v-if="showPopup"
      @on-close="showPopup = false"
      @on-download="onHandleDownload"
    />
    <transition name="slide-up">
      <div class="back-to-top-button" v-if="opacityStickyHeader > 0.2">
        <div class="button" @click="scrollToTop">Back to top</div>
      </div>
    </transition>
    <Observer @on-change="onBottomObserved">
      <div style="height: 1px; width: 100%; background: #992258"></div>
    </Observer>
  </div>
</template>
<script>
import Observer from "vue-intersection-observer";
import SmoothReflow from "../../components/smoothReflow/SmoothReflow.vue";
import { debounce } from "lodash";

export default {
  components: {
    TeaserView: () => import("./teaserView.vue"),
    HeaderView: () => import("./components/staticHeader.vue"),
    StickyHeader: () => import("./components/stickyHeader.vue"),
    GridItem: () => import("./components/gridItem.vue"),
    PopupReport: () => import("./components/popupReport.vue"),
    Observer,
    SmoothReflow,
  },
  data() {
    return {
      showSticky: false,
      opacityStickyHeader: 0,
      showPopup: false,
      selectedReport: {},
      scrollDebounce: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
    this.scrollDebounce = debounce(this.handleScroll, 25); // Adjust the delay as needed
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    this.scrollDebounce.cancel();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onHandleDownload() {
      this.showPopup = false;
      this.$router.push("/download");
    },
    onClickReport(item) {
      this.$store.dispatch("$_User/setSelectedReport", item);
      this.showPopup = true;
    },
    handleScroll() {
      if (this.showPopup) {
        return;
      }
      this.showSticky = window.scrollY > 150;
      if (this.showSticky) {
        const scrollY = window.scrollY - 250;
        this.opacityStickyHeader = Math.min(scrollY / 200, 1);
      } else {
        this.opacityStickyHeader = 0;
      }
    },
    onScroll() {
      this.scrollDebounce();
    },
    onBottomObserved(entry, unobserve) {
      if (
        entry.isIntersecting &&
        !this.InsightFactoryStore.loadingFetch &&
        !this.InsightFactoryStore.loadingCount
      ) {
        this.$store.dispatch("$_InsightFactory/fetchReports").then(() => {
          const { reportCount, reports } = this.InsightFactoryStore;
          if (reportCount === 0 || reportCount <= reports.length) {
            unobserve();
          }
        });
      }
    },
  },
  computed: {
    InsightFactoryStore() {
      return this.$store.state.$_InsightFactory;
    },
    is_loading_fetch_report() {
      return this.$store.state.$_InsightFactory.loadingFetch;
    },
    reports() {
      return this.$store.state.$_InsightFactory.reports;
    },
    report_exist() {
      return this.$store.state.$_InsightFactory.reportCount > 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.back-to-top-button {
  -webkit-tap-highlight-color: transparent;
  @media (min-width: 769px) {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  .button {
    font-family: $lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 16.8px;
    color: #ffffff;
    background-color: #000000;
    border-radius: 20px;
    padding: 8px 16px;
  }
  .button:hover,
  .button:active,
  button:focus {
    -webkit-tap-highlight-color: transparent;
  }
}
.home-page {
  background: #f2f0f0;
  position: relative;
}

.home-page-content {
  background: #992258;
  margin-top: 24px;
  padding: 40px;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 30%));

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, 100%);
    padding: 24px 16px;
    row-gap: 16px;
  }

  justify-content: center;
  column-gap: 30px;
  row-gap: 30px;
}

@keyframes slideUp {
  from {
    transform: translateY(-100%);
    height: 0px;
    min-height: 0px;
  }
  to {
    transform: translateY(0);
    height: 102px;
    min-height: 102px;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(-100%);
    height: 0px;
    min-height: 0px;
    opacity: 0;
  }
  to {
    transform: translateY(0);
    height: 102px;
    min-height: 102px;
    opacity: 1;
  }
}

.smooth-opacity {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
